import styled from "styled-components";

interface HomeworkContentModalProps{
    isOpen:boolean,
    contentList:string[],
    onConfirmClickHandler:() => void
}


const HomeworkContentModal = ({isOpen, contentList, onConfirmClickHandler}:HomeworkContentModalProps) => {
    if(!isOpen){
        return null;
    }

    const renderContentList = () => {
        return contentList.map((item, index) => {
            return <TableRow><Audio src={item} controls/></TableRow>
        })
    }
    
    return(
        <Container>
            <Modal>
                <TitleWrap>
                    <Title>콘텐츠 보기</Title>
                </TitleWrap>
                <Content>
                    <Table>
                        <TableHeader>
                            <TableColumn>듣기</TableColumn>
                        </TableHeader>
                        <TableBody>
                            {renderContentList()}
                        </TableBody>
                    </Table>
                </Content>
                <ButtonWrap>
                    <Button onClick={onConfirmClickHandler}>닫기</Button>
                </ButtonWrap>
            </Modal>
        </Container>
    )
}

const Container = styled.div`
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 100vh;
    min-width: 100vw;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    padding: 48px;
`

const Modal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 16px;
    width: 400px;
    min-width: 300px;
    background-color: white;
    border-radius: 16px;
    animation: fadeInUp 0.5s ease-in-out;
`

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 24px;
`;

const ButtonWrap = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
`

const Button = styled.button`
    height: 50px;
    padding: 0 40px;
    background-color: #df0000;
    color: white;
    border: none;
    border-radius: 52px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s;
`;

const Content = styled.div`
    display: flex;
    gap: 20px;
    flex-grow: 1;
    width: 100%;
`

const Table = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
`

const TableHeader = styled.div`
    display: flex;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    background-color: #E5E5E5;
`

const TableColumn = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-left: 1px solid #ccc;
    padding: 8px;
    &:first-child{
        border-left: none;
        width: 70%;
    }
    width: 30%;
    font-size: 16px;
`

const TableBody = styled.div`
    flex-grow: 1;
    height: 500px; /* 고정된 처음 높이 설정 */
    min-height: 500px; /* 최소 높이 설정 */
    overflow: auto;  /* 스크롤 가능하게 설정 */
`

const TableRow = styled.div<{selected?:boolean}>`
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: 8px;
    background-color: ${(props) => props.selected ? "#ccc" : "none"};
    font-weight: ${(props) => props.selected ? 600 : 400};
    &:hover{
        background-color: #ccc;
    }
`

const Audio = styled.audio`
    width: 100%;
`


export default HomeworkContentModal;